import { render, staticRenderFns } from "./batchReview.vue?vue&type=template&id=667786ce&scoped=true"
import script from "./batchReview.vue?vue&type=script&lang=js"
export * from "./batchReview.vue?vue&type=script&lang=js"
import style0 from "./batchReview.vue?vue&type=style&index=0&id=667786ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667786ce",
  null
  
)

export default component.exports